import { useTheme } from '@mui/material';
import { type FC, useMemo } from 'react';

import { hasValue } from '@core/utils/equality';
import { useSlabQuery } from '@web/hooks/useSlabQuery';

import { buildPlantPins } from './mapPins';
import { PinMarkers, type PinMarkersProps } from './PinMarkers';

type Props = PinMarkersProps & {
  excludedPlantIds?: string[];
};

export const PlantMarkers: FC<Props> = ({ excludedPlantIds, ...props }) => {
  const theme = useTheme();
  const { data: plants } = useSlabQuery('GET plants', {});

  const pins = useMemo(() => {
    const plantPins = buildPlantPins(plants?.items ?? [], theme);
    if (!hasValue(excludedPlantIds)) return plantPins;

    return plantPins.filter((pin) => !excludedPlantIds.includes(pin.id));
  }, [plants, theme, excludedPlantIds]);

  return <PinMarkers pins={pins} {...props} />;
};
